import React from "react";
import { useParams } from "react-router-dom";
import { Entry, Track } from "../../GratefulDB";
import AUD from "../../images/AUD.png";
import EntryImage from "./EntryImage";
import EntryTags from "./EntryTags";
import "./SearchResultItem.scss";
import { useNavUtils } from "./useNavUtils";

const SearchResultItem: React.FC<{
  entry: Entry;
}> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const SBD = require(`../../images/${process.env.REACT_APP_SBD_IMAGE}`);

  const params = useParams<{ term?: string }>();
  const navUtils = useNavUtils();

  const containsSearchTerm = (term: string) => {
    if (!params.term || params.term.length < 3) {
      return false;
    }
    return term.toLowerCase().includes(params.term.toLowerCase());
  };

  return (
    <div
      className="item SearchResultItem"
      onClick={() => navUtils.show(props.entry.identifier, params.term)}
    >
      <div className="image mobile-hidden">
        {props.entry.image ? (
          <EntryImage image={props.entry.image} />
        ) : (
          <img src={props.entry.isSoundboard ? SBD : AUD} />
        )}
      </div>
      <div className="content">
        <a className="header">{props.entry.date}</a>
        <div className="meta">
          <span className="cinema">
            {props.entry.venue}, {props.entry.coverage}
          </span>
        </div>
        <div className="description">
          <p className="setlist">
            {props.entry.tracks.map((track: Track) => (
              <i
                key={track.name}
                className={`${
                  containsSearchTerm(track.title) ? "search-term" : ""
                }`}
              >
                {track.title}
              </i>
            ))}
          </p>
        </div>
        <div className="extra">
          <EntryTags entry={props.entry} />
        </div>
      </div>
    </div>
  );
};

export default SearchResultItem;
